import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { WelcomeScreen } from './components/WelcomeScreen';
import { PromptForm } from './components/PromptForm';
import { ResultScreen } from './components/ResultScreen';

export default function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <main className="max-w-7xl mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <Routes>
            <Route path="/" element={<WelcomeScreen />} />
            <Route path="/create" element={<PromptForm />} />
            <Route path="/result" element={<ResultScreen />} />
          </Routes>
        </div>
      </main>

      <footer className="bg-white border-t border-gray-200 py-6 mt-auto">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-600">
          <p>Powered by Advanced AI Technology</p>
        </div>
      </footer>
    </div>
  );
}